import React, {useState} from 'react';
import './groupResults.css';
import {useDispatch, useSelector} from "react-redux";
import group from "../index";
import GroupCard from "../groupCard/groupCard";
import {Spinner, TitlePage} from "../../shared";
import {FormattedMessage, useIntl} from "react-intl";
import GroupReload from "../groupReload";
import {ogFunctions} from "../../../apis/og-functions/ogFunctionsApi";
import ButtonV2 from "../../shared/button-v2/button-v2";

function GroupResults({hideTitle}) {

    const dispatch = useDispatch();
    const intl = useIntl();

    const search = useSelector(group.selectors.getGroupSearch);

    const [loadingMoreItems, setLoadingNewItems] = useState(false);
    const userGroups = useSelector(group.selectors.userGroups);

    if (!search?.groups || !userGroups?.groups) {
        return (
            <div>
                <GroupReload/>
                {!hideTitle &&
                    <TitlePage icon="fa-solid fa-users-rectangle"
                               leftClass="col-12"
                               title={
                                   <div>
                                       <FormattedMessage id="search-results.title"/>
                                   </div>
                               }/>}
                <div className="d-flex flex-row justify-content-center">
                    <Spinner/>
                </div>
            </div>
        )
    }

    const loadMoreItems = async () => {
        setLoadingNewItems(true);
        const data = {keywords: search.keywords, page: search.page + 1};
        const nextPageSearch = ogFunctions.httpsCallable('findGroupsByKeywords');
        const res = await nextPageSearch(data);
        res.data.keywords = search.keywords;
        dispatch(group.actions.groupSearchNewPageLoaded(res.data));
        setLoadingNewItems(false);
    }

    return (
        <div className="mt-4 w-100 pb-4">
            <GroupReload/>
            <div style={{fontSize: "small"}} className="mb-2">
                <FormattedMessage id="group-search.showing-results"/>
                <b>{search.keywords}</b>
            </div>
            {!search.groups.length &&
                <div className="alert alert-info mt-2" role="alert">
                    <FormattedMessage id="group-search.no-results"/>
                </div>
            }
            <div style={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: '20px',
                padding: 15,
            }}>
                {search.groups.map(x => {
                    return <GroupCard key={x.id} group={x} invited={userGroups.groupInvites.some(y => y === x.id)}
                                      joined={userGroups.groups.some(y => y.id === x.id)}
                                      asked={userGroups.askedGroups.some(y => y === x.id)}/>

                })}
            </div>
            {search.groups.length > 0 &&
                <div style={{width: '100%'}} className='d-flex justify-content-center'>
                    {search.moreItems &&
                        <ButtonV2
                            className="btn btn-outline-secondary d-flex flex-column justify-content-center text-center"
                            onClick={loadMoreItems}
                            disabled={loadingMoreItems}>
                            <div>
                                <FormattedMessage id="group-search.load-more"/>
                            </div>
                            <div className="text-center" style={{width: '100%'}}>
                                {!loadingMoreItems && <i className="fa-solid fa-plus"></i>}
                                {loadingMoreItems && <i className="fa-solid fa-spinner fa-spin"></i>}
                            </div>
                        </ButtonV2>}
                    {!search.moreItems &&
                        <div>
                            <hr style={{marginBottom: 0}}/>
                            <span style={{fontSize: "small", fontWeight: 'normal'}}>No more items found for the given keywords</span>
                        </div>}
                </div>}

        </div>
    );
}

export default GroupResults;
